module.exports = __webpack_public_path__ + "img/gray-plus.9fcdbdec.svg";